import { useEffect, useState } from "react";
import DataTable from "../../utils/DataTable";
import ApiServices from "../../config/ApiServices";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import * as qs from "qs";

export default function ManageTrainers({ title }) {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const isOpen = useSelector((state) => state.modal.isOpen);
  const [status, setStatus] = useState(1);

  useEffect(() => {
    if (isOpen === false) {
      dispatch(showLoader());
      let body = {};
      if (status == 1) body.status = true;
      else body.status = false;

      ApiServices.apiRequest("getTrainer", qs.stringify(body))
        .then((res) => {
          if (res.data.success) {
            setData(res.data.data);
            setFilteredData(res.data.data);
            console.log("trainers data is:", res.data.data);
          } else toast.error(res.data.message);
        })
        .catch((err) => toast.error(err?.message))
        .finally(() => {
          setTimeout(() => {
            dispatch(hideLoader());
          }, 1000);
        });
    }
  }, [status, isOpen, dispatch]);

  // Filter data whenever filter or data changes
  useEffect(() => {
    const result = data.filter(
      (trainer) =>
        trainer.name?.toLowerCase().includes(filter.toLowerCase()) ||
        trainer.email?.toLowerCase().includes(filter.toLowerCase())
    );
    setFilteredData(result);
  }, [filter, data]);

  const columns = [
    { fields: "empId", headerName: "Employee-Id" },
    { fields: "name", headerName: "Employee Name" },
    { fields: "email", headerName: "Email" },
  ];

  return (
    <>
      <div className="container">
        <div className="page-inner">
          {loading && !isOpen ? (
            <Loader />
          ) : (
            <>
              <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                <div>
                  <h3 className="fw-bold mb-3">{title}</h3>
                  <select
                    className="form-select p-2"
                    onChange={(e) => setStatus(e.target.value)}
                    value={status}
                  >
                    <option value={1}>Active</option>
                    <option value={2}>In-Active</option>
                  </select>
                </div>

                {/* 🔹 Search Input */}
                <div className="ms-md-3 py-1 mt-2 py-md-0">
                  <input
                    type="text"
                    className="form-control mt-lg-5"
                    placeholder="Search by name or email"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />
                </div>

                <div className="ms-md-auto py-2 py-md-0 mt-lg-5">
                  <button
                    onClick={() => dispatch(showModal("AddTrainers"))}
                    className="btn btn-primary btn-round"
                  >
                    Add Trainer
                  </button>
                </div>
              </div>

              {/* Pass filteredData to DataTable and a unique key to re-render when filter changes */}
              <DataTable
                key={filter} // resets pagination when search changes
                rows={filteredData}
                columns={columns}
                status={status}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}
